import React, { useState, useEffect } from 'react';
import axios from '../../../library/axios';
import { MySwal } from '../../../library/swal';
import Button from 'react-bootstrap/Button';
import { IconDeviceFloppy, IconSquareX } from '@tabler/icons-react';
import { validationAccess } from "../../../helpers/validationAccess"
import {
  getModule, setHrefWithSlugHook, getSlug
} from "../../../../src/config/routes/guards/slug";
import { useLocation } from 'react-router';
import { getApiErrorMessage } from '../../../helpers/apiErrorMessage';
import { notifyApiLoadError } from '../../../helpers/notifyApiError';

const CreateRiskActivityTargetsComp = (props) => {
  //   console.log(props);
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [name, setname] = useState('');
  const [goals, setgoals] = useState('');

  const location = useLocation();
  const [role, setRole] = useState('');

  const fetchOneUser = async () => {
    try {
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      setRole(data?.data?.mapping_user_groups[0]?.group?.namaGroup);
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/risk-activity-targets/create.fetchOneUser');
    }
  };

  const fetchLoginStatus = async () => {
    try {
      await validationAccess(getModule())
      const options = {
        url: `/users/detailUser`,
        method: 'GET',
        headers: {
          'Access-Control-Allow-Origin': '*',
          Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}`,
        },
      };
      const { data } = await axios(options);
      // console.log(data)
      if (data.login === false) {
        MySwal.fire({
          icon: 'info',
          title: 'Oops, Unauthorize!',
          text: 'Session anda habis, Silahkan login kembali.',
        });

        setTimeout(() => {
          localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
          localStorage.clear();
          setHrefWithSlugHook('/login');
        }, 3000);
      } else {
        let check = data?.data?.mapping_groups?.some(
          (mp) => location.pathname == mp?.module?.pathModule
        );

        if (check === false) {
          MySwal.fire({
            icon: 'info',
            title: 'Oops, No Access!',
            text: 'Anda tidak memiliki akses di halaman ini.',
          });

          setTimeout(() => {
            localStorage.removeItem(`token${getSlug() ? '-' + getSlug() : ''}`);
            setHrefWithSlugHook('/login');
          }, 3000);
        }
      }
    } catch (err) {
      notifyApiLoadError(err, 'components/moleculs/risk-activity-targets/create.fetchLoginStatus');
    }
  };

  useEffect(() => {
    fetchLoginStatus();
    fetchOneUser();
  }, []);

  const handleCreate = () => {
    setLoading(true);
    setDisabled(true);

    const requestBody = {
      name: name,
      goals: goals,
    };
    // console.log(requestBody);
    // return false;
    axios({
      url: '/activity-targets/create',
      method: 'POST',
      data: requestBody,
      headers: { Authorization: `Bearer ${localStorage.getItem(`token${getSlug() ? '-' + getSlug() : ''}`)}` },
    })
      .then((res) => {
        // console.log(res)
        // return false
        if (res.status === 200) {
          MySwal.fire({
            icon: 'success',
            title: 'Success',
            text: 'Successfully tambah laporan!',
          });

          setLoading(false);
          setDisabled(false);

          props.close();
          props.fetch();
        }
      })
      .catch((err) => {
        setLoading(false);
        setDisabled(false);
        if (err !== '') {
          console.log(err?.response?.data?.message);
          MySwal.fire({
            icon: 'error',
            title: 'Oops, Error!',
            text: getApiErrorMessage(err),
          });
        }
      });
  };

  return (
    <div>
      <div className="row">
        <div className="col-12">
          <div className="mb-5">
            <label htmlFor="name" className="form-label required">
              Nama Kegiatan
            </label>
            <textarea
              className="form-control row-cols-3"
              id="name"
              onChange={(e) => setname(e.target.value)}
              value={name}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-12">
          <div className="mb-5">
            <label htmlFor="goals" className="form-label required">
              Tujuan Kegiatan (S.M.A.R.T)
            </label>
            <textarea
              className="form-control row-cols-3"
              id="goals"
              onChange={(e) => setgoals(e.target.value)}
              value={goals}
            ></textarea>
          </div>
        </div>
      </div>

      <div className="mt-5 row">
        <div className="d-flex flex-center flex-row-fluid pt-2">
          <Button
            disabled={disabled}
            variant="primary"
            size="sm"
            onClick={() => handleCreate()}
          >
            <IconDeviceFloppy stroke={2} />{' '}
            {loading === true ? 'Mohon Tunggu..' : 'Simpan'}
          </Button>
          &nbsp;
          <Button variant="danger" size="sm" onClick={() => props.close()}>
            <IconSquareX stroke={2} /> Tutup
          </Button>
        </div>
      </div>
    </div >
  );
};

export default CreateRiskActivityTargetsComp;
